var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 757,
    height: 634,
    viewBox: "0 0 757 634",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.958 634C561.258 634 695.26 632.611 695.26 630.897C695.26 629.183 561.258 627.794 395.958 627.794C230.658 627.794 96.6562 629.183 96.6562 630.897C96.6562 632.611 230.658 634 395.958 634Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.232 618.257L555.816 583.274L556.85 542.456L550.004 523.01L473.23 514.259L417.82 553.131L434.098 604.561L459.62 614.367L507.232 618.257Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M548.06 630.897L573.314 589.087L556.85 542.456L555.816 583.274L507.232 618.257L459.62 614.368L434.098 604.561L442.123 629.925L548.06 630.897Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.251 628.353L142.138 623.408L142.283 617.615L141.311 614.864L130.432 613.623L122.572 619.146L124.889 626.429L128.508 627.815L135.251 628.353Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.021 630.152L144.62 624.236L142.283 617.616L142.138 623.408L135.251 628.353L128.508 627.815L124.889 626.429L126.026 630.008L141.021 630.152Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.763 618.257L341.376 609.878L354.655 594.921L324.54 550.214L255.625 548.539L215.707 586.191L232.067 607.23L252.626 617.285L316.763 618.257Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.567 629.925L341.375 609.878L316.763 618.257L252.625 617.285L232.066 607.23L249.709 629.925H323.567Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M638.465 621.546L655.776 616.809L659.851 605.989L646.242 579.736L607.358 584.598L583.076 607.933L588.226 614.533L607.358 619.601L638.465 621.546Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.102 629.325L655.777 616.809L638.465 621.546L607.358 619.602L588.227 614.533L600.554 630.297L651.102 629.325Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.658 624.38L165.655 621.381L163.09 614.492L172.687 600.755L196.389 600.92L211.819 615.733L208.53 619.933L196.389 623.139L176.658 624.38Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.633 629.304L165.654 621.381L176.658 624.38L196.389 623.139L208.53 619.933L200.712 629.925L168.633 629.304Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.566 364.024L388.098 630.897H404.148L403.217 364.872L389.566 364.024Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.217 364.872L391.945 364.169L400.569 369.072L398.15 625.829L391.821 627.711L388.139 623.739L388.098 630.897H404.148L403.217 364.872Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.57 234.518L299.039 311.311L354.428 365.741L448.204 364.769L494.347 307.422L493.396 234.042L434.594 176.199H352.959L297.57 234.518Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.959 239.11L311.241 306.243L359.66 353.825L441.626 352.976L481.958 302.829L481.13 238.697L429.733 188.136H358.378L309.959 239.11Z",
    fill: "#9790C1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.426 365.741L448.202 364.768L494.346 307.422L493.394 234.042L480.385 221.257L490.064 235.945L489.009 306.905L445.286 357.941L354.426 361.334L302.988 311.704L298.541 285.534L299.037 311.311L354.426 365.741Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.94 230.628L481.131 238.697L481.958 302.829L441.627 352.976L359.66 353.825L311.242 306.243L310.932 289.899L314.096 304.96L360.736 348.715L437.035 343.853L475.898 302.043L478.318 240.331L472.94 230.628Z",
    fill: "#8379BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.083 278.108L355.392 248.323H364.06V276.797H370.076V284.541H364.06V293H355.541V284.541H333.083V278.108ZM342.912 276.797H355.541V276.112C355.541 273.292 355.571 270.503 355.63 267.742C355.69 264.982 355.849 262.123 356.107 259.164L342.912 276.797ZM376.098 270.661C376.098 265.896 376.703 261.775 377.914 258.301C379.146 254.826 380.962 252.145 383.365 250.259C385.768 248.372 388.726 247.429 392.241 247.429C395.776 247.429 398.734 248.372 401.117 250.259C403.52 252.145 405.327 254.826 406.538 258.301C407.769 261.775 408.385 265.896 408.385 270.661C408.385 275.427 407.769 279.547 406.538 283.022C405.327 286.497 403.52 289.178 401.117 291.064C398.734 292.951 395.776 293.894 392.241 293.894C388.726 293.894 385.768 292.951 383.365 291.064C380.962 289.178 379.146 286.497 377.914 283.022C376.703 279.547 376.098 275.427 376.098 270.661ZM385.212 270.661C385.212 275.328 385.807 279.031 386.999 281.771C388.19 284.492 389.938 285.852 392.241 285.852C394.544 285.852 396.292 284.492 397.483 281.771C398.675 279.031 399.27 275.328 399.27 270.661C399.27 265.975 398.675 262.272 397.483 259.552C396.292 256.831 394.544 255.471 392.241 255.471C389.938 255.471 388.19 256.831 386.999 259.552C385.807 262.272 385.212 265.975 385.212 270.661ZM415.597 278.108L437.907 248.323H446.574V276.797H452.591V284.541H446.574V293H438.055V284.541H415.597V278.108ZM425.427 276.797H438.055V276.112C438.055 273.292 438.085 270.503 438.145 267.742C438.204 264.982 438.363 262.123 438.621 259.164L425.427 276.797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.938 154.559L198.644 129.568L199.388 100.419L194.486 86.5376L139.656 80.2692L100.09 108.053L111.714 144.774L129.935 151.787L163.938 154.559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.1 163.579L211.135 133.727L199.388 100.419L198.643 129.568L163.937 154.559L129.934 151.787L111.713 144.774L117.442 162.896L193.1 163.579Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.671 155.076L132.252 149.098L141.745 138.423L120.235 106.501L71.0099 105.301L42.4883 132.175L54.1741 147.215L68.8589 154.394L114.671 155.076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.532 163.414L132.252 149.098L114.671 155.076L68.8587 154.394L54.1738 147.215L66.7904 163.414H119.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.967 157.952L235.335 154.58L238.231 146.843L228.51 128.099L200.753 131.575L183.4 148.229L187.082 152.946L200.753 156.566L222.967 157.952Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.985 163.496L235.335 154.58L222.967 157.952L200.753 156.566L187.082 152.946L195.893 164.2L231.985 163.496Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.72 162.028C279.72 163.786 217.341 165.234 140.359 165.234C63.3776 165.234 0.998047 163.786 0.998047 162.028C0.998047 160.269 63.3982 158.842 140.359 158.842C217.32 158.842 279.72 160.269 279.72 162.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.569 73.2767L389.256 69.3667L385.885 60.4088L398.419 42.5138L429.298 42.7414L449.381 62.0225L445.12 67.4841L429.298 71.6837L403.569 73.2767Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.124 79.7105L389.256 69.3666L403.568 73.2766L429.298 71.6837L445.12 67.484L434.903 80.5174L393.124 79.7105Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.149 74.2696L521.855 49.2787L522.599 20.1295L517.697 6.24798L462.867 0.000244141L423.301 27.7633L434.925 64.4843L453.146 71.4975L487.149 74.2696Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M516.29 83.3102L534.346 53.4576L522.598 20.1295L521.854 49.2787L487.148 74.2696L453.145 71.4974L434.924 64.4843L440.653 82.6068L516.29 83.3102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.157 77.6831L558.546 74.2903L561.442 66.5738L551.721 47.8306L523.964 51.3061L506.611 67.9598L510.293 72.6767L523.964 76.2971L546.157 77.6831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.195 83.2275L558.546 74.2903L546.157 77.6831L523.964 76.2971L510.293 72.6767L519.104 83.9309L555.195 83.2275Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.025 81.7586C613.025 83.5171 550.625 84.9446 473.664 84.9446C396.703 84.9446 334.303 83.5171 334.303 81.7586C334.303 80.0002 396.703 78.6141 473.664 78.6141C550.625 78.6141 613.025 80.0002 613.025 81.7586Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.343 176.571L723.947 174.233L725.974 168.834L718.445 158.076L699.872 158.2L687.793 169.806L690.358 173.096L699.872 175.599L715.343 176.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.609 180.44L723.946 174.233L715.342 176.571L699.872 175.599L690.357 173.096L696.5 180.916L721.609 180.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.083 177.171L644.234 162.152L643.779 144.629L646.737 136.271L679.685 132.527L703.47 149.222L696.5 171.296L685.538 175.495L665.083 177.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M647.564 182.591L636.727 164.655L643.779 144.629L644.234 162.152L665.083 177.171L685.538 175.495L696.5 171.296L693.046 182.178L647.564 182.591Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M629.613 179.219L622.167 177.192L620.43 172.537L626.262 161.262L642.953 163.352L653.398 173.364L651.185 176.199L642.953 178.371L629.613 179.219Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.193 182.55L622.166 177.192L629.612 179.219L642.952 178.371L651.184 176.199L645.869 182.964L624.193 182.55Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.404 181.66C589.404 182.736 626.923 183.584 673.191 183.584C719.458 183.584 756.997 182.736 756.997 181.66C756.997 180.585 719.479 179.757 673.191 179.757C626.902 179.757 589.404 180.605 589.404 181.66Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 756,
    height: 634,
    fill: "white",
    transform: "translate(0.998047 0.000244141)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorw);
export default __webpack_public_path__ + "static/media/errorw.9ec9819c.svg";
export { ForwardRef as ReactComponent };